/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Upgrade_ToInputs */

const en_plan_upgrade_to = /** @type {(inputs: Plan_Upgrade_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade to this plan`)
};

const es_plan_upgrade_to = /** @type {(inputs: Plan_Upgrade_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejorar a este plan`)
};

/**
* | output |
* | --- |
* | "Upgrade to this plan" |
*
* @param {Plan_Upgrade_ToInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_upgrade_to = /** @type {((inputs?: Plan_Upgrade_ToInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Upgrade_ToInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_upgrade_to(inputs)
	return en_plan_upgrade_to(inputs)
});